/* eslint-disable react/no-unknown-property */
import { useLoader } from '@react-three/fiber'
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader'

export default function PLYModel({ source, ...props }) {
  // object 是一个 BufferGeometry 对象
  const object = useLoader(PLYLoader, source)

  /**
   * points 组件用于显示点
   * @dispose：是否在组件卸载时销毁，默认是 true
   * @position：点的位置，默认是 (0, 0, 0)
   * @rotation：点的旋转，默认是 (0, 0, 0)
   * @scale：点的缩放，默认是 (1, 1, 1)
   * @visible：点是否可见，默认是 true
   * @userData：点的用户数据，默认是 {}
   * @castShadow：是否投射阴影，默认是 false
   * @receiveShadow：是否接收阴影，默认是 false
   * @frustumCulled：是否裁剪，默认是 true
   * @renderOrder：渲染顺序，默认是 0
   * @material：点的材质，默认是 null
   * @geometry：点的几何结构，默认是 null
   * @layers：点的图层，默认是 null
   * @attach：点的附加属性，默认是 null
   * @attachArray：点的附加属性数组，默认是 null
   * @attachObject：点的附加属性对象，默认是 null
   * @attachObjectArray：点的附加属性对象数组，默认是 null
   * @attachRefs：点的附加属性引用，默认是 null
   * @attachRefsArray：点的附加属性引用数组，默认是 null
   * @drawRange：点的绘制范围，默认是 { start: 0, count: Infinity }
   * @drawRange.start：点的绘制起始位置，默认是 0
   * @drawRange.count：点的绘制数量，默认是 Infinity
   */
  return (
    <points geometry={object} colorsNeedUpdate>
      <pointsMaterial
        attach="material"
        vertexColors
        size={2}
        sizeAttenuation={false}
      />
    </points>
  )
}
